import { render, staticRenderFns } from "./star-outline.vue?vue&type=template&id=66550e5d&scoped=true&"
import script from "./star-outline.vue?vue&type=script&lang=js&"
export * from "./star-outline.vue?vue&type=script&lang=js&"
import style0 from "./star-outline.vue?vue&type=style&index=0&id=66550e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66550e5d",
  null
  
)

export default component.exports